import React, { useState, useRef, useEffect } from "react";
import { arrowDownIcon, arrowUpIcon } from "../../assets/icons/SvgIconList";
import UseTranslationHook from "../../hooks/UseTranslationHook";
import { cn } from "../../lib";

const ICDropDownGroup = ({ options }: any) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [myCss, setMyCss] = useState(false);
  const { t } = UseTranslationHook();
  const handleSelect = (value1: any, value2: any, value3: any) => {
    setSelectedValue(value1);

    setIsDropdownOpen(false);
  };

  const contentRef: React.MutableRefObject<HTMLDivElement | null> =
    useRef(null);

  const handleOutsideClick = (event: MouseEvent) => {
    if (
      contentRef.current &&
      !contentRef.current.contains(event.target as Node)
    ) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (contentRef.current) {
        const contentRect = contentRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const remainingSpace = viewportHeight - contentRect.bottom;

        if (remainingSpace < 300) {
          setMyCss(true);
        } else {
          setMyCss(false);
        }
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [contentRef?.current?.getBoundingClientRect()]);

  return (
    <div className="custom-dropdown-group" ref={contentRef}>
      <div
        className={cn(`selected-value-group`, {
          "p-2 cursor-pointer": isDropdownOpen,
        })}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {selectedValue || t("select_an_option")}
        {isDropdownOpen ? (
          <span className="absolute top-1/2 right-3 transform -translate-y-1/2 transition-transform duration-300 size-5">
            {arrowUpIcon}
          </span>
        ) : (
          <span className="absolute top-1/2 right-3 transform -translate-y-1/2 transition-transform duration-300 size-5">
            {arrowDownIcon}
          </span>
        )}
      </div>
      {isDropdownOpen && (
        <ul
          className="absolute left-0 w-full bg-subtle border border-t-0 border-gray-300 rounded-b-md list-none p-0 m-0 z-10 overflow-y-scroll h-[300px]"
          style={{
            top: myCss ? "" : "100%",
            bottom: myCss ? "100%" : "",
          }}
        >
          {options.map((group: any) => (
            <li key={group.label}>
              <div className={`bg-gray-200 p-2 font-bold sticky top-0 z-10`}>
                {group.label}
              </div>
              <ul style={{ textDecoration: "none" }}>
                {group.options.map((option: any) => (
                  <li
                    key={option.value}
                    className={cn(
                      `p-2 pl-6 cursor-pointer transition-colors duration-200`,
                      { selected: option === selectedValue }
                    )}
                    onClick={() =>
                      handleSelect(option.name, option.value, group.label)
                    }
                  >
                    {option.name}
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ICDropDownGroup;
